













import { Locale } from 'vue-i18n';
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import SettingProfile from '@/components/organisms/SettingProfile.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { loginUserModule } from '@/store/modules/LoginUserStore';

@Component({
  components: { PortalAppBar, SettingProfile },
})
export default class SettingBody extends Vue {
  @Prop()
  private loading!: boolean;
  @Prop()
  private isMultilangugeEnabled!: boolean;
  @Prop()
  private isPortalEnabled!: boolean;

  private get language(): Locale {
    return loginUserModule.userInfo.language;
  }

  private get usageFavorite(): boolean {
    return loginUserModule.userInfo.useFavoritePanel;
  }

  @Emit('change-use-favorite')
  private changeUsageFavorite(usage: boolean): boolean {
    return usage;
  }

  @Emit('setting-change-lang')
  private changeLanguage(language: Locale): Locale {
    return language;
  }
}
